import Enum from "../../../../../enums/Enum";

const LevelEnum = new Enum({
    PRINCIPAL: {name: "Principal"},
    SECONDARY: {name: "Secondary"}
});

export default LevelEnum;